/**
 * This implements a client for the GraphQL API that works outside
 * of our code-generated hooks. We've implemented it this way because
 * we're managing fetching, error handling, and loading outside of the
 * React lifecycle in a state machine. This fits more cleanly into this
 * paradigm because we can initialize the machine without having to inject
 * the results of a hook into it.
 *
 * In the future we will likely want to codegen this client as well
 * because there are quite a few places where we do this and will continue
 * to do so.
 */
import apollo from '~/lib/apollo';

import query from './query.graphql';

export async function fetchProspects(context: any) {
  const { data, error } = await apollo.query({
    query: query,
    variables: {
      domains: context.domains,
      titles: context.personQuery.title ?? [],
      seniorities: context.personQuery.seniority ?? [],
      roles: context.personQuery.role ?? [],
      employeesRanges: context.companyQuery.employeesRanges ?? [],
      companyTags: context.companyQuery.companyTags ?? [],
      industries: context.companyQuery.industries ?? [],
      page: context.currentPage ?? 1,
    },
  });

  if (error) {
    throw new Error('Error fetching prospects');
  }

  return data;
}
